module.exports = __webpack_public_path__ + "img/fplogo-iab.6a429232.png";